import React, { useState } from 'react'
import styled from 'styled-components'
import { trackDeal } from '../googleTagManager'
import { sendContactDataToHS } from '../hubspot'

export function NewsletterSignup() {
  const [email, setEmail] = useState('')
  const [complete, setComplete] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [loading, setLoading] = useState(false)
  const [accepted, setAccepted] = useState(false)

  return (
    <>
      {!complete ? (
        <form
          className="form cta-form"
          onSubmit={async (e: React.FormEvent) => {
            e.preventDefault()
            await onSubmit({ email }, setComplete, setErrorMsg, setLoading)
          }}
        >
          <input
            className="email"
            type="email"
            placeholder="Your email address"
            minLength={5}
            required
            onChange={e => {
              setEmail(e.target.value)
            }}
            value={email}
          />
          <LegalContainer>
            <input
              type="checkbox"
              id="consent"
              required
              checked={accepted}
              onChange={() => setAccepted(!accepted)}
            />
            <label htmlFor="consent">
              I confirm I want to receive Swarmia news and updates.{' '}
            </label>
          </LegalContainer>

          <button disabled={loading || !accepted} className="big primary">
            Subscribe now
          </button>
          <div className="error-message">{errorMsg}</div>
        </form>
      ) : (
        <div className="thank-you">
          🎉 <b>You&#39;re on the list!</b> We&#39;ll take it from here.
          <br />
          Enjoy the rest of your day.
        </div>
      )}
    </>
  )
}

export default NewsletterSignup

async function onSubmit(
  dealData: ContactData,
  setComplete: (value: boolean) => void,
  setErrorMsg: (value: string) => void,
  setLoading: (value: boolean) => void,
) {
  setLoading(true)
  try {
    const res = await sendContactDataToHS(
      dealData,
      'd2fbe13f-3c80-458a-84ee-c46036dea41b',
    )
    trackDeal('email', dealData)
    if (res.status === 200) {
      setComplete(true)
      setErrorMsg('')
    } else {
      setErrorMsg('Oops, an error. Please try again.')
      // @ts-ignore
      Sentry.captureException(JSON.stringify(res)) // eslint-disable-line
    }
  } catch (error) {
    // @ts-ignore
    Sentry.captureException(error) // eslint-disable-line
  } finally {
    setLoading(false)
  }
}

interface ContactData {
  email: string
}

const LegalContainer = styled.div`
  text-align: left;
  margin-bottom: 16px;

  .unsubscribe {
    opacity: 0.5;
  }

  label {
    margin-left: 4px;
  }

  input[type='checkbox'] {
    margin-left: 0;
    vertical-align: middle;
  }
`
